import React from 'react';
import RadicalLogoSVG from "../svg/radicalLogo";

const Loading = (props) => {
    const styleParent = {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 999,
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%'
    };

    const styleLogo = {
        maxWidth: '65%'
    }

    return (
        <div style={styleParent}>
            <RadicalLogoSVG style={styleLogo}/>
        </div>
    );

};

export default Loading;